if (!customElements.get('sidi-postage')) {
  customElements.define('sidi-postage', class extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      document.addEventListener('cart:updated', this.refresh);
      document.addEventListener('cart:refresh', this.refresh);
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
      this.refresh();
    }
    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.refresh);
      document.removeEventListener('cart:refresh', this.refresh);
      if (this.unsubscribe) this.unsubscribe();
      if (this.controller) this.controller.abort();
    }
    async refresh() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const controller = this.controller;
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart.js', { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (this.controller === controller) this.render(cart);
      } catch (error) {
        if (this.controller === controller && this.isConnected) this.querySelector('[data-postage-line]').textContent = this.dataset.fallback;
      } finally { clearTimeout(timeout); }
    }
    render(cart) {
      this.hidden = cart.item_count === 0;
      this.style.display = this.hidden ? 'none' : 'block';
      const line = this.querySelector('[data-postage-line]');
      const change = this.querySelector('[data-postage-change]');
      const money = cents => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(cents / 100);
      let rate = null;
      let label = '';
      if (this.dataset.country === 'GB' && cart.currency === 'GBP') {
        const weight = cart.items.reduce((sum, item) => sum + (item.requires_shipping ? Number(item.grams) * item.quantity : 0), 0);
        if (cart.total_price >= 7000) { rate = 0; label = this.dataset.free; }
        else if (weight <= 1860) { rate = 399; label = this.dataset.small; }
        else if (weight >= 1905 && weight <= 7257) { rate = 649; label = this.dataset.medium; }
      }
      let text = rate === null ? this.dataset.fallback : rate === 0 ? label : this.dataset.estimate + ': ' + money(rate) + ' · ' + label;
      if (this.dataset.country === 'GB' && cart.currency === 'GBP' && cart.total_price < 7000) text += ' · ' + this.dataset.remaining.replace('[amount]', money(7000 - cart.total_price));
      line.textContent = text;
      const previous = this.constructor.previousRate;
      change.textContent = rate !== null && previous !== undefined && rate !== previous && cart.item_count ? (rate > previous ? this.dataset.increase : this.dataset.decrease).replace('[amount]', money(Math.abs(rate - previous))) : '';
      if (!cart.item_count) delete this.constructor.previousRate;
      else if (rate !== null) this.constructor.previousRate = rate;
    }
  });
}
